<!-- (c) 津职模拟考 -->
<template>
  <div class="detail" v-if="course">
    <nav-header :title="header_title"></nav-header>
    <div class="course-conver">
      <img :src="course.coverUri" />
    </div>
    <div class="course-title">{{ course.title }}</div>
    <div class="course-brief-introduction">{{ course.briefIntroduction }}</div>
    <div class="choice-box">
      <van-tabs title-active-color="#3ca7fa" color="#3ca7fa">
        <van-tab :title="item.name" v-for="(item, index) in navs" :key="index">
          <div class="cap-item u-content" v-if="index === 0">
            <div class="u-content md-content">
              <div
                class="desc"
                v-html="
                  course.description.replace(
                    /<img/g,
                    '<img style=&quot;width:100%;height:auto;&quot;'
                  )
                "
                style="font-size: 16px"
              ></div>
            </div>
          </div>
          <div class="cap-item chapters" v-else-if="index === 1">
            <van-collapse
              accordion
              v-model="activeName"
              @change="onChange"
              :border="false"
            >
              <van-collapse-item
                :title="item1.title"
                :name="index1 + 1"
                v-for="(item1, index1) in chapters"
                :key="index1"
              >
                <div
                  class="videos"
                  v-for="(item2, index2) in videos[item1.id]"
                  :key="index2"
                  @click="goStudy(item2.id, course.id)"
                >
                  <div class="video-title">
                    <span class="text">{{ item2.title }}</span>
                  </div>
                  <div class="video-duration">
                    <duration-text :duration="item2.duration"></duration-text>
                  </div>
                </div>
              </van-collapse-item>
            </van-collapse>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="study" v-if="lessons.length > 0">
      <span class="study-btn" @click="goStudy(lessons[0].id, course.id)"
        >前往学习</span
      >
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Collapse } from "vant-green";
import { CollapseItem } from "vant-green";
import { Tabs } from "vant-green";
import { Tab } from "vant-green";
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Tabs);
Vue.use(Tab);
import { mapState } from "vuex";
import DurationText from "../../components/duration-text.vue";
import NavHeader from "../../components/nav-header.vue";

export default {
  components: {
    DurationText,
    NavHeader,
  },
  data() {
    return {
      id: "",
      course: null,
      chapters: [],
      navs: [
        {
          name: "介绍",
        },
        {
          name: "章节",
        },
      ],
      videos: {},
      activeName: 1,
      lessons: [],
      header_title: "课程详情",
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapState(["isLogin"]),
  },
  methods: {
    getData() {
      var that = this;
      this.$api.Course.courseDetail(this.$route.query.id).then((res) => {
        var data = res.data;
        that.course = data.course;
        that.chapters = data.chapters;
        that.lessons = data.lessons;
        if (data.chapters.length > 0) {
          that.navs = [
            {
              name: "介绍",
            },
            {
              name: "章节",
            },
          ];
        } else {
          that.navs = [
            {
              name: "介绍",
            },
          ];
        }
        if (data.chapters.length > 0 && data.lessons.length > 0) {
          data.chapters.forEach(function (e) {
            that.videos[e.id] = [];
            data.lessons.forEach(function (k) {
              if (e.id == k.chapterId) {
                that.videos[e.id].push(k);
              }
            });
          }, that);
        }
      });
    },
    onChange(event) {
      console.log(event.detail);
      this.activeName = event.detail;
    },
    goStudy(id, cid) {
      if (!this.isLogin) {
        this.$router.push({
          name: "Login",
          query: {
            url: window.location.href,
          },
        });
        return;
      }
      if (!this.course.userCanJoin) {
        this.$message.error("暂无权限");
        return;
      }
      this.$router.push({
        name: "CourseStudy",
        query: {
          id: id,
          cid: cid,
        },
      });
      return;
    },
  },
};
</script>
<style>
.detail {
  width: 100%;
  box-sizing: border-box;
}

.course-conver {
  width: 100%;
}

.course-conver img {
  width: 100%;
}

.course-title {
  width: 100%;
  height: auto;
  float: left;
  box-sizing: border-box;
  padding: 15px 15px 0 15px;
  font-size: 16px;
  font-weight: 500;
  color: #171923;
  word-break: break-all;
  line-height: 24px;
  background-color: #fff;
}

.course-brief-introduction {
  width: 100%;
  height: auto;
  float: left;
  box-sizing: border-box;
  padding: 15px 15px 15px 15px;
  font-size: 14px;
  font-weight: 500;
  color: #999999;
  word-break: break-all;
  line-height: 24px;
  background-color: #fff;
}

.choice-box {
  width: 100%;
  height: auto;
  float: left;
  box-sizing: border-box;
  background-color: #fff;
  border-top: 10px solid #f1f2f6;
}
.u-content {
  padding: 10px 10px 40px 10px !important;
}
.cap-item {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-top: 1px solid #ddd;
  height: auto;
  float: left;
  color: #333333;
  line-height: 25px;
  box-sizing: border-box;
}

.u-content {
  padding: 20px 15px 80px 15px;
}

.cap-item [src] {
  max-width: 100%;
  margin-top: 10px;
}

.chapters {
  padding-bottom: 80px;
}

.van-cell__title {
  color: #000;
}

.videos {
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  line-height: 36px;
  box-sizing: border-box;
  padding: 0 10px 0 10px;
  background: #f6f6f6;
  border-radius: 4px;
}

.video-title {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  color: #333;
}

.video-duration {
  width: auto;
  height: auto;
  font-size: 12px;
  margin-left: 10px;
  color: #999999;
}

.study {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 990;
  width: 100%;
  height: 53px;
  box-sizing: border-box;
  background-color: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  box-sizing: border-box;
  padding-left: 15px;
  padding-right: 15px;
  overflow: hidden;
  text-align: center;
}

.study-btn {
  flex: 1;
  display: block;
  text-align: center;
  margin: 4px 0px;
  line-height: 40px;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #3ca7fa;
}
</style>
